import { ImgHTMLAttributes, useState } from 'react';
import { FaGlobe } from 'react-icons/fa6';
import classNames from 'classnames';

export const normalizeDomain = (domain?: string | null): string => {
  if (!domain) return '';

  return domain
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .split('/')[0];
};

export const getDomainFaviconUrl = (domain?: string | null): string =>
  `https://www.google.com/s2/favicons?sz=32&domain=${encodeURIComponent(
    normalizeDomain(domain)
  )}`;

type DomainFaviconProps = {
  domain?: string | null;
  width?: number;
  className?: string;
} & Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height' | 'className' | 'alt' | 'loading' | 'onError'
>;

const DomainFavicon = ({
  domain,
  width = 16,
  className = 'rounded-circle',
  ...props
}: DomainFaviconProps) => {
  const [hasError, setHasError] = useState(false);
  const normalizedDomain = normalizeDomain(domain);

  if (!normalizedDomain || hasError) {
    return (
      <FaGlobe
        size={width}
        className={classNames('text-500 flex-shrink-0', className)}
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      loading="lazy"
      width={width}
      height={width}
      className={className}
      src={getDomainFaviconUrl(normalizedDomain)}
      alt=""
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default DomainFavicon;
